import type { ModalOverlayProps } from "react-aria-components";

import type { ReactNode } from "react";

import clsx from "clsx";
import { Dialog, Heading, Modal, ModalOverlay } from "react-aria-components";

import { CloseIcon } from "../../icons/close";
import { Button } from "../button";

import styles from "./popup.module.css";

type PopupProps = {
	actions?: ReactNode;
	close?: () => void;
	customBody?: ReactNode;
	description?: string;
	dialogClassName?: string;
	isOpen?: boolean;
	title: string;
} & ModalOverlayProps;

export function Popup({
	actions,
	close,
	customBody,
	description = "",
	dialogClassName,
	isOpen,
	title,
	...props
}: PopupProps): ReactNode {
	return (
		<ModalOverlay
			className={styles.overlay}
			isDismissable
			isOpen={isOpen}
			onOpenChange={(isOpen) => {
				return !isOpen && close?.();
			}}
		>
			<Modal {...props} isDismissable isKeyboardDismissDisabled>
				<Dialog className={clsx(styles.dialog, dialogClassName)} data-testid="popup">
					<header className={styles.header}>
						<Heading className="title-2" level={2} slot="title">
							{title}
						</Heading>
						<Button iconOnly onPress={close} slot="close" variant="secondary">
							<CloseIcon />
						</Button>
					</header>
					<div className={styles.content}>
						{customBody ? customBody : <p className="body-1">{description}</p>}
						{actions && <div className={styles.actions}>{actions}</div>}
					</div>
				</Dialog>
			</Modal>
		</ModalOverlay>
	);
}
